<template>
  <v-container fluid class="pa-3">
    <v-card outlined class="pa-4">
      <div class="text-h6 mb-1">{{ $route.meta.title }}</div>
      <v-chip small outlined color="warning" class="mb-3">En adaptación</v-chip>
      <p class="body-2 mb-4">{{ $route.meta.pendingReason }}</p>
      <v-btn small color="accent" :to="{ name: 'routes' }" v-if="canRoutes">Ir al catálogo de rutas</v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { can } from '../../src/helpers/permissions';

export default {
  computed: {
    ...mapGetters('configuration', ['getAbilitiesUser']),
    canRoutes() { return can(this.getAbilitiesUser, 'get-routes'); },
  },
};
</script>
